/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Proprietary code. Licensed, not sold. See LICENSE.md and Services Agreement.
 */

/**
 * Exocet 2026 — global compare modal (specs table only)
 */
(function () {
  if (window.__exocetCompareModalInit) return;
  window.__exocetCompareModalInit = true;
  var boundOverlay = null;
  var events;
  function listen(target, type, handler) {
    target.addEventListener(type, handler, { signal: events.signal });
  }
  var OVERLAY_ID = "compare-modal-overlay-2026";

  function getOverlay() {
    return document.getElementById(OVERLAY_ID);
  }

  function getDialog() {
    var el = getOverlay();
    return el ? el.querySelector('[role="dialog"]') : null;
  }

  function getCheckedIdsFromDom() {
    var list = [];
    document.querySelectorAll("[data-compare-checkbox]:checked").forEach(function (cb) {
      list.push(String(cb.dataset.productId || cb.value));
    });
    return list;
  }

  function extractFromCard(pid) {
    var sid = String(pid).replace(/\\/g, "").replace(/"/g, "");
    var card = document.querySelector('[data-product-card][data-product-id="' + sid + '"]');
    if (!card) {
      return {
        id: sid,
        title: "",
        price: "",
        url: "",
        image: "",
        construction: "",
        volume: "",
        length: "",
        width: "",
      };
    }
    return {
      id: String(card.dataset.productId || pid),
      title: card.dataset.productTitle || "",
      price: card.dataset.productPrice || "",
      url: card.dataset.productUrl || "",
      image: card.dataset.productImage || "",
      construction: card.dataset.productConstruction || "",
      volume: card.dataset.productVolume || "",
      length: card.dataset.productLength || "",
      width: card.dataset.productWidth || "",
    };
  }

  function getSlots() {
    var overlay = getOverlay();
    if (!overlay) return [];
    return Array.prototype.slice.call(overlay.querySelectorAll("[data-compare-slot]"));
  }

  function clearSlot(slot) {
    slot.classList.add("is-empty");
    var imgWrap = slot.querySelector("[data-compare-slot-image]");
    var title = slot.querySelector("[data-compare-slot-title]");
    var price = slot.querySelector("[data-compare-slot-price]");
    var empty = slot.querySelector("[data-compare-slot-empty]");
    var removeBtn = slot.querySelector("[data-compare-slot-remove]");
    if (imgWrap) imgWrap.innerHTML = "";
    if (title) {
      title.textContent = "";
      title.style.display = "none";
    }
    if (price) {
      price.textContent = "";
      price.style.display = "none";
    }
    if (empty) empty.style.display = "";
    if (removeBtn) removeBtn.hidden = true;
    delete slot.dataset.productId;
  }

  function renderSlot(slot, data) {
    slot.classList.remove("is-empty");
    slot.dataset.productId = data.id;
    var imgWrap = slot.querySelector("[data-compare-slot-image]");
    var title = slot.querySelector("[data-compare-slot-title]");
    var price = slot.querySelector("[data-compare-slot-price]");
    var empty = slot.querySelector("[data-compare-slot-empty]");
    var removeBtn = slot.querySelector("[data-compare-slot-remove]");
    if (imgWrap) {
      imgWrap.innerHTML = "";
      if (data.image) {
        var img = document.createElement("img");
        img.src = data.image;
        img.alt = data.title || "";
        img.loading = "lazy";
        img.decoding = "async";
        imgWrap.appendChild(img);
      }
    }
    if (title) {
      title.textContent = data.title || "";
      title.style.display = data.title ? "" : "none";
    }
    if (price) {
      price.textContent = data.price || "";
      price.style.display = data.price ? "" : "none";
    }
    if (empty) empty.style.display = "none";
    if (removeBtn) removeBtn.hidden = false;
  }

  function buildLink(url) {
    var overlay = getOverlay();
    var a = document.createElement("a");
    a.href = url;
    a.className = "compare-modal-2026__link";
    a.textContent = overlay && overlay.dataset.viewLabel ? overlay.dataset.viewLabel : (window.exocetCompareConfig?.strings?.viewProduct || "");
    return a;
  }

  function firstThText(overlay, rowKey) {
    var row = overlay.querySelector('[data-compare-row="' + rowKey + '"]');
    if (!row) return rowKey;
    var th = row.querySelector("th");
    return (th && th.textContent && th.textContent.trim()) || rowKey;
  }

  function fillTable(entries) {
    var overlay = getOverlay();
    if (!overlay) return;

    overlay.querySelectorAll("[data-compare-row]").forEach(function (row) {
      var rowKey = row.getAttribute("data-compare-row");
      for (var i = 1; i <= 3; i++) {
        var cell = row.querySelector('td[data-cell="' + i + '"]');
        if (!cell) continue;
        var data = entries[i - 1];
        cell.textContent = "";
        while (cell.firstChild) cell.removeChild(cell.firstChild);
        cell.removeAttribute("data-label");
        var label = firstThText(overlay, rowKey);
        if (!data) {
          cell.textContent = "\u2014";
          cell.dataset.label = label;
          continue;
        }
        cell.dataset.label = label;
        if (rowKey === "volume") {
          cell.textContent = data.volume || "\u2014";
        } else if (rowKey === "construction") {
          cell.textContent = data.construction || "\u2014";
        } else if (rowKey === "length") {
          cell.textContent = data.length || "\u2014";
        } else if (rowKey === "width") {
          cell.textContent = data.width || "\u2014";
        } else if (rowKey === "price") {
          cell.textContent = data.price || "\u2014";
        } else if (rowKey === "link") {
          if (data.url) {
            cell.appendChild(buildLink(data.url));
          } else {
            cell.textContent = "\u2014";
          }
        }
      }
    });
  }

  function syncSlotsFromDom(idsOptional) {
    var ids = idsOptional && idsOptional.length ? idsOptional.slice(0, 3) : getCheckedIdsFromDom().slice(0, 3);
    var entries = ids.map(function (id) {
      return extractFromCard(id);
    });
    var slots = getSlots();

    slots.forEach(function (slot, idx) {
      clearSlot(slot);
      if (entries[idx]) {
        renderSlot(slot, entries[idx]);
      }
    });

    fillTable(entries);

    for (var col = 0; col < 3; col++) {
      var th = document.querySelector("[data-compare-th-" + String(col + 1) + "]");
      if (th) {
        var def = th.getAttribute("data-default-label") || "";
        th.textContent = entries[col] && entries[col].title ? entries[col].title.slice(0, 40) : def || "\u2014";
      }
    }
  }

  var prevFocusEl = null;
  var tabTrapHandler = null;
  var closeFallbackTimer = null;
  var MOTION_MS = 280;

  function openModal() {
    var overlay = getOverlay();
    var dialog = getDialog();
    if (!overlay || !dialog) return;
    if (closeFallbackTimer) {
      clearTimeout(closeFallbackTimer);
      closeFallbackTimer = null;
    }
    overlay.removeAttribute("hidden");
    overlay.setAttribute("aria-hidden", "false");
    overlay.classList.remove("is-open");
    void overlay.offsetWidth;
    overlay.classList.add("is-open");
    prevFocusEl = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    if (tabTrapHandler) dialog.removeEventListener("keydown", tabTrapHandler);

    tabTrapHandler = function (e) {
      if (e.key !== "Tab") return;
      var focusables = dialog.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      );
      var list = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null || overlay.contains(el);
      });
      if (list.length < 2) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    dialog.addEventListener("keydown", tabTrapHandler);

    requestAnimationFrame(function () {
      dialog.focus({ preventScroll: true });
      var fc = dialog.querySelector("button, [href], input, select");
      if (fc) fc.focus({ preventScroll: true });
    });
  }

  function finishCloseModal() {
    var overlay = getOverlay();
    var dialog = getDialog();
    if (!overlay) return;

    overlay.setAttribute("hidden", "hidden");

    if (dialog && tabTrapHandler) dialog.removeEventListener("keydown", tabTrapHandler);

    if (prevFocusEl) prevFocusEl.focus({ preventScroll: true });
    prevFocusEl = null;
  }

  function closeModal() {
    var overlay = getOverlay();
    if (!overlay) return;

    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");

    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reducedMotion) {
      finishCloseModal();
      return;
    }

    var closed = false;
    function onTransitionEnd(e) {
      if (closed) return;
      if (e.target !== overlay) return;
      closed = true;
      overlay.removeEventListener("transitionend", onTransitionEnd);
      if (closeFallbackTimer) clearTimeout(closeFallbackTimer);
      finishCloseModal();
    }

    overlay.addEventListener("transitionend", onTransitionEnd);
    closeFallbackTimer = setTimeout(function () {
      if (closed) return;
      closed = true;
      overlay.removeEventListener("transitionend", onTransitionEnd);
      finishCloseModal();
    }, MOTION_MS);
  }

  function clearAllCompare() {
    document.querySelectorAll("[data-compare-checkbox]").forEach(function (cb) {
      cb.checked = false;
      var card = cb.closest("[data-product-card]");
      if (card) card.classList.remove("is-selected");
    });
    syncSlotsFromDom([]);
    document.dispatchEvent(new CustomEvent("compare:updated", { detail: { count: 0, productIds: [] }, bubbles: true }));
    closeModal();
  }

  function removePidFromSelection(pid) {
    document.querySelectorAll("[data-compare-checkbox]").forEach(function (cb) {
      if (String(cb.dataset.productId || cb.value) === String(pid)) cb.checked = false;
    });
    document.querySelectorAll("[data-product-card]").forEach(function (card) {
      if (String(card.dataset.productId) === String(pid)) card.classList.remove("is-selected");
    });

    var next = getCheckedIdsFromDom();
    document.dispatchEvent(
      new CustomEvent("compare:updated", {
        detail: { count: next.length, productIds: next },
        bubbles: true,
      }),
    );
    syncSlotsFromDom(next);
  }

  function initTableHeadersFallback() {
    for (var i = 1; i <= 3; i++) {
      var th = document.querySelector("[data-compare-th-" + String(i) + "]");
      if (th && !th.getAttribute("data-default-label")) {
        th.setAttribute("data-default-label", th.textContent.trim());
      }
    }
  }

  function init() {
    var overlay = getOverlay();
    if (!overlay || overlay === boundOverlay) return;
    if (events) events.abort();
    events = new AbortController();
    boundOverlay = overlay;

    initTableHeadersFallback();
    syncSlotsFromDom([]);

    listen(overlay, "click", function (e) {
      if (e.target === overlay) closeModal();
    });

    overlay.querySelectorAll("[data-compare-modal-close], [data-compare-modal-close-footer]").forEach(function (btn) {
      listen(btn, "click", closeModal);
    });

    var clearBtn = overlay.querySelector("[data-compare-modal-clear]");
    if (clearBtn) listen(clearBtn, "click", clearAllCompare);

    getSlots().forEach(function (slot) {
      var btn = slot.querySelector("[data-compare-slot-remove]");
      if (btn) {
        listen(btn, "click", function () {
          var pid = slot.dataset.productId;
          if (pid) removePidFromSelection(pid);
        });
      }
    });

    listen(document, "keydown", function (e) {
      if (e.key === "Escape" && overlay.classList.contains("is-open")) closeModal();
    });

    listen(document,
      "compare:open",
      function (e) {
        var raw = e && e.detail && e.detail.productIds;
        var ids = raw && raw.length ? raw.map(String) : getCheckedIdsFromDom();
        syncSlotsFromDom(ids.slice(0, 3));
        openModal();
      },
    );

    listen(document,
      "compare:updated",
      function () {
        syncSlotsFromDom();
      },
    );
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", function (event) {
    if (!boundOverlay || !event.target.contains(boundOverlay)) return;
    clearTimeout(closeFallbackTimer);
    finishCloseModal();
    events.abort();
    boundOverlay = null;
  });
})();
